import $ from "jquery";
import "slick-carousel";


const testSlider = 'home-promos-slider';

$(`.${testSlider}`).on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(`.controls-dots-${testSlider}`).data("theme");
    dots.addClass('slick-dot ' + theme);
  }
});


$(`.${testSlider}`).slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  appendDots: $(`.controls-dots-${testSlider}`),
  nextArrow: $(`.controls-next-${testSlider}`),
  prevArrow: $(`.controls-prev-${testSlider}`),
});